import React, { useEffect, useState } from 'react';
import { StyledArticlesColumn } from './StyledArticlesColumn';
import { useLocation,useHistory } from 'react-router-dom';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";
import { BaseUrl } from "../../config";

const ArticlesColumn = ({ articles, isCategory, slug , isIndex}) => {
  const [displayedArticles, setDisplayedArticles] = useState([])
  const [indexArticles, setIndexArticles] = useState(isIndex ? 4 : 5)
  const [hideLoadMore, setHideLoadMore] = useState(false)
  const [pagination, setPagination] = useState(1)
  const [paginationArray, setPaginationArray] = useState([]);
  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const incrementFactor = isIndex ? 4 : 5;
  
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
  const loadNextPagination = () => {

    fetch(`${BaseUrl}/page?key=invrsion&slug=${slug}&page=${slug}&page=${pagination + 1}`, {
      method: 'GET',
      headers : { 
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    }).then((json) =>  {
      setPaginationArray([...paginationArray, ...json.data.index_news.list_news])
      setPagination(pagination + 1)
      if(json.data.index_news.list_news.length === 0){
        setHideLoadMore(true)
      }
    })

  }
  const handleLoadMore = () => {
    let allArticles = [...articles, ...paginationArray]
    let lastIndex = allArticles.length;
    if(indexArticles + incrementFactor >= lastIndex) {
      loadNextPagination()
    }
    let nextIndex = indexArticles + incrementFactor > lastIndex ? indexArticles + (lastIndex - indexArticles) : indexArticles + incrementFactor;
    let splitNextFive = allArticles.slice(indexArticles, nextIndex)
    
    let indexIncrement = indexArticles + incrementFactor
    setIndexArticles(indexIncrement)
    
    var newArray = [...displayedArticles, ...splitNextFive ]
    
    setDisplayedArticles(newArray);
    
    
  }

  useEffect(()=>{
    setHideLoadMore(articles.length <= incrementFactor);
    setDisplayedArticles(articles.slice(0, indexArticles))
  },[])
  return (
    <React.Fragment>
      {
       
          <StyledArticlesColumn isIndex={isIndex}>
            {
              isCategory &&
              <h4 className="md--title category-title">{slug.replace('-', ' ')}</h4>
            }
            <div className="articles-column">
              {
                displayedArticles.map((key, index) => {
                  return  <div className="article-row" key={index}>
                            <div className="article-text">
                              <p className="preset-13 category" onClick={() => handleCLick(`/news/category/${key.category.toLowerCase().replace(' ', '-')}`)}>{key.category}</p>
                              <p className="preset-9 title-article" onClick={() => handleCLick(`/news/${key.slug}`)}>{key.title}</p>
                              <div className="details-wrapper">
                                <div className="detail-col">
                                  <img src="/calendar-date.svg" />
                                  <p className="preset-12">{key.date}</p>
                                </div>
                                <div className="detail-col">
                                  <img src="/time.svg" />
                                  <p className="preset-12">{key.reading_time} min read</p>
                                </div>
                              </div>
                            </div>
                            <div className="article-img">
                              <div className="box-preview" style={{backgroundImage: `url(${key.tumb})`}}>
                              </div>
                            </div>
                          </div>
                })
              }
              {
                !hideLoadMore &&
                <div className="load-btn" onClick={() => handleLoadMore()}>
                  <p className="preset-10">Load more</p>
                  <img src="/rotate.svg" />
                </div>
              }
            </div>
          </StyledArticlesColumn>
          
      }
    </React.Fragment>
  );
};

export default ArticlesColumn;
